import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partners\Enaos\GetPlacesByWikiCity::__invoke
* @see app/Http/Controllers/Partners/Enaos/GetPlacesByWikiCity.php
* @route '/api/partner/enaos/places'
*/
const GetPlacesByWikiCity = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlacesByWikiCity.url(options),
    method: 'get',
})

GetPlacesByWikiCity.definition = {
    methods: ["get","head"],
    url: '/api/partner/enaos/places',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Partners\Enaos\GetPlacesByWikiCity::__invoke
* @see app/Http/Controllers/Partners/Enaos/GetPlacesByWikiCity.php
* @route '/api/partner/enaos/places'
*/
GetPlacesByWikiCity.url = (options?: RouteQueryOptions) => {
    return GetPlacesByWikiCity.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partners\Enaos\GetPlacesByWikiCity::__invoke
* @see app/Http/Controllers/Partners/Enaos/GetPlacesByWikiCity.php
* @route '/api/partner/enaos/places'
*/
GetPlacesByWikiCity.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlacesByWikiCity.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Partners\Enaos\GetPlacesByWikiCity::__invoke
* @see app/Http/Controllers/Partners/Enaos/GetPlacesByWikiCity.php
* @route '/api/partner/enaos/places'
*/
GetPlacesByWikiCity.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPlacesByWikiCity.url(options),
    method: 'head',
})

export default GetPlacesByWikiCity